import validate from "/usr/src/app/content/n3-spas-15f97452-afed-42b0-873f-630d9e795e87/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-15f97452-afed-42b0-873f-630d9e795e87/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}